<app-generic-loader [isLoader]="isLoading"></app-generic-loader>
<div class="topics-config-container">
  <!-- Toolbar -->
  <div class="topics-toolbar">
    <div class="topics-label-area">
      <span class="topics-label">Topics</span>

      <!-- Info icon when no snapshot configuration -->
      <span
        class="info-icon"
        *ngIf="!hasSnapshotConfiguration"
        title="No snapshot configuration found. Please configure snapshot settings first."
      >
        ⓘ
      </span>

      <!-- Brand select wrapper when snapshot is configured -->
      <div class="brand-select-wrapper" *ngIf="hasSnapshotConfiguration">
        <select class="topics-brand-select" [(ngModel)]="selectedBrand">
          <option *ngFor="let b of brandOptions" [value]="b.value">
            {{ b.label }}
          </option>
        </select>
        <span
          class="info-icon"
          *ngIf="!isSelectedBrandConfigured()"
          title="Configure at least one Section/Sub-section to enable the feature."
        >
          ⓘ
        </span>
      </div>
    </div>
    <div class="topics-action-btns">
      <button
        class="topics-action-btn"
        [disabled]="!hasSnapshotConfiguration"
        (click)="addNewRow()"
      >
        <img src="assets/images/common/Add.svg" alt="add" /> Add New Row
      </button>
      <button
        class="topics-action-btn"
        [disabled]="!hasSnapshotConfiguration"
        (click)="download()"
      >
        <img
          src="assets/images/common/download-color-icon.svg"
          alt="download"
        />
        Download
      </button>
      <button
        class="topics-action-btn"
        [disabled]="!hasSnapshotConfiguration"
        (click)="triggerUpload()"
      >
        <img src="assets/images/common/Upload.svg" alt="upload" /> Upload
      </button>
      <input
        type="file"
        #fileInput
        style="display: none"
        (change)="onFileSelected($event)"
      />
    </div>
  </div>

  <!-- Grid Table -->
  <div
    class="topics-table-wrapper"
    [class.disabled]="!hasSnapshotConfiguration"
  >
    <div class="topics-grid">
      <!-- Header Row -->
      <div
        class="grid-header"
        [ngClass]="isProductTracker ? 'producttracker' : ''"
      >
        <div class="grid-cell grid-cell--check">
          <input
            type="checkbox"
            [checked]="allSelected"
            (change)="selectAll($event)"
          />
        </div>
        <div class="grid-cell">Snapshot Type</div>
        <div class="grid-cell">Section Name</div>
        <div class="grid-cell">Sub Section Name</div>
        <div class="grid-cell">Entry Point 1</div>
        <div class="grid-cell">Entry Point 2</div>
        <div class="grid-cell">Entry Point 3</div>
        <div class="grid-cell" *ngIf="isProductTracker">ProductList</div>
        <div class="grid-cell">( Provision)<br />Dimension 1</div>
        <div class="grid-cell">( Provision)<br />Dimension 2</div>
        <div class="grid-cell">( Provision)<br />Dimension 3</div>
        <div class="grid-cell">BrandList</div>
        <div class="grid-cell">Duplicate<br />Row</div>
      </div>

      <!-- Data Rows -->
      <div
        class="grid-row"
        [ngClass]="isProductTracker ? 'producttracker' : ''"
        *ngFor="let row of rows; let i = index"
        [class.grid-row--even]="i % 2 !== 0"
      >
        <div class="grid-cell grid-cell--check">
          <input type="checkbox" [(ngModel)]="row.selected" />
        </div>
        <div class="grid-cell grid-cell--snapshot-type">
          <div
            class="radio-dropdown"
            DocumentClick
            (DocumentClicked)="closeDropdown(i)"
          >
            <div class="radio-dropdown-trigger" (click)="toggleDropdown(i)">
              <span>{{ getLabelForValue(row.snapshotType) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="openDropdownIndex === i"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="openDropdownIndex === i">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_snapshotType']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label
                  *ngFor="
                    let opt of filterOptions(
                      snapshotTypeOptions,
                      dropdownSearch[i + '_snapshotType']
                    )
                  "
                  class="radio-option"
                >
                  <input
                    type="radio"
                    [name]="'snapshotType_' + i"
                    [value]="opt.value"
                    [(ngModel)]="row.snapshotType"
                    (change)="onSnapshotTypeChange(opt.label, i)"
                  />
                  <span>{{ opt.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="!row.snapshotType"
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'section')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="row.snapshotType && toggleEpDropdown(i, 'section')"
            >
              <span>{{ getSectionLabel(row.sectionName) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'section')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'section')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_section']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label
                  *ngFor="
                    let s of filterOptions(
                      rowSectionOptions[i] || [],
                      dropdownSearch[i + '_section']
                    )
                  "
                  class="radio-option"
                >
                  <input
                    type="radio"
                    [name]="'sectionName_' + i"
                    [value]="s"
                    [(ngModel)]="row.sectionName"
                    (change)="
                      onSectionChange(s, i); epOpenState[i + '_section'] = false
                    "
                  />
                  <span>{{ s }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="
              !row.sectionName || !getAvailableSubSections(row, i).length
            "
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'subSection')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="
                row.sectionName &&
                  getAvailableSubSections(row, i).length &&
                  toggleEpDropdown(i, 'subSection')
              "
            >
              <span>{{ getSubSectionLabel(row.subSectionName) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'subSection')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'subSection')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_subSection']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label
                  *ngFor="
                    let s of filterOptions(
                      getAvailableSubSections(row, i),
                      dropdownSearch[i + '_subSection']
                    )
                  "
                  class="checkbox-option"
                >
                  <input
                    type="checkbox"
                    [checked]="isEpChecked(row.subSectionName, s)"
                    (change)="toggleSubSection(row, s, i)"
                  />
                  <span>{{ s }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="!row.sectionName"
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'ep1')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="row.sectionName && toggleEpDropdown(i, 'ep1')"
            >
              <span>{{ getEpLabel(row.entryPoint1) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'ep1')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'ep1')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_ep1']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label class="checkbox-option select-all-option">
                  <input
                    type="checkbox"
                    [checked]="
                      isAllEpSelected(
                        row.entryPoint1,
                        rowEntryPoint1Options[i] || []
                      )
                    "
                    (change)="
                      toggleSelectAllEp(
                        row.entryPoint1,
                        rowEntryPoint1Options[i] || [],
                        i
                      )
                    "
                  />
                  <span>Select All</span>
                </label>
                <label
                  *ngFor="
                    let opt of filterOptions(
                      rowEntryPoint1Options[i] || [],
                      dropdownSearch[i + '_ep1']
                    )
                  "
                  class="checkbox-option"
                   title="{{ opt.value }}"
                >
                  <input
                    type="checkbox"
                    [checked]="isEpChecked(row.entryPoint1, opt.value)"
                    (change)="onEpChange(row.entryPoint1, opt.value, i)"
                  />
                  <span>{{ opt.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="!row.sectionName || !rowEntryPoint2Enabled[i]"
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'ep2')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="
                row.sectionName &&
                  rowEntryPoint2Enabled[i] &&
                  toggleEpDropdown(i, 'ep2')
              "
            >
              <span>{{ getEpLabel(row.entryPoint2) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'ep2')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'ep2')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_ep2']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label class="checkbox-option select-all-option">
                  <input
                    type="checkbox"
                    [checked]="
                      isAllEpSelected(
                        row.entryPoint2,
                        rowEntryPoint2Options[i] || []
                      )
                    "
                    (change)="
                      toggleSelectAllEp(
                        row.entryPoint2,
                        rowEntryPoint2Options[i] || [],
                        i
                      )
                    "
                  />
                  <span>Select All</span>
                </label>
                <label
                  *ngFor="
                    let opt of filterOptions(
                      rowEntryPoint2Options[i] || [],
                      dropdownSearch[i + '_ep2']
                    )
                  "
                  class="checkbox-option" title="{{ opt.value }}"
                >
                  <input
                    type="checkbox"
                    [checked]="isEpChecked(row.entryPoint2, opt.value)"
                    (change)="onEpChange(row.entryPoint2, opt.value, i)"
                  />
                  <span>{{ opt.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="!row.sectionName || !rowEntryPoint3Enabled[i]"
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'ep3')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="
                row.sectionName &&
                  rowEntryPoint3Enabled[i] &&
                  toggleEpDropdown(i, 'ep3')
              "
            >
              <span>{{ getEpLabel(row.entryPoint3) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'ep3')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'ep3')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_ep3']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label class="checkbox-option select-all-option">
                  <input
                    type="checkbox"
                    [checked]="
                      isAllEpSelected(
                        row.entryPoint3,
                        rowEntryPoint3Options[i] || []
                      )
                    "
                    (change)="
                      toggleSelectAllEp(
                        row.entryPoint3,
                        rowEntryPoint3Options[i] || [],
                        i
                      )
                    "
                  />
                  <span>Select All</span>
                </label>
                <label
                  *ngFor="
                    let opt of filterOptions(
                      rowEntryPoint3Options[i] || [],
                      dropdownSearch[i + '_ep3']
                    )
                  "
                  class="checkbox-option"
                >
                  <input
                    type="checkbox"
                    [checked]="isEpChecked(row.entryPoint3, opt.value)"
                    (change)="onEpChange(row.entryPoint3, opt.value, i)"
                  />
                  <span>{{ opt.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <!-- Product column -->
        <div class="grid-cell" *ngIf="isProductTracker">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="isProductDisabled(row, i)"
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'product')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="
                !isProductDisabled(row, i) && toggleEpDropdown(i, 'product')
              "
            >
              <span>{{ getProductLabel(row.productList) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'product')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'product')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_product']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <label
                  *ngFor="
                    let opt of filterOptions(
                      rowProductOptions[i] || [],
                      dropdownSearch[i + '_product']
                    )
                  "
                  class="checkbox-option"
                  title="{{ opt.value }}"
                >
                  <input
                    type="checkbox"
                    [checked]="isEpChecked(row.productList, opt.value)"
                    (change)="onProductChange(row, opt.value)"
                  />
                  <span>{{ opt.label }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell">
          <select [(ngModel)]="row.dimension1" [disabled]="true">
            <option value="">Select</option>
          </select>
        </div>
        <div class="grid-cell">
          <select [(ngModel)]="row.dimension2" [disabled]="true">
            <option value="">Select</option>
          </select>
        </div>
        <div class="grid-cell">
          <select [(ngModel)]="row.dimension3" [disabled]="true">
            <option value="">Select</option>
          </select>
        </div>
        <div class="grid-cell">
          <div
            class="ep-dropdown"
            [class.ep-disabled]="isBrandListDisabled(row, i)"
            DocumentClick
            (DocumentClicked)="closeEpDropdown(i, 'brand')"
          >
            <div
              class="radio-dropdown-trigger"
              (click)="
                !isBrandListDisabled(row, i) && toggleEpDropdown(i, 'brand')
              "
            >
              <span>{{ getBrandLabel(row.brandList) }}</span>
              <div
                class="drop-arrow"
                [class.drop-arrow--open]="isEpOpen(i, 'brand')"
              ></div>
            </div>
            <div class="radio-dropdown-panel" *ngIf="isEpOpen(i, 'brand')">
              <input
                type="text"
                class="dropdown-search"
                placeholder="Search..."
                [(ngModel)]="dropdownSearch[i + '_brand']"
                (click)="$event.stopPropagation()"
              />
              <div class="radio-dropdown-options">
                <ng-container
                  *ngIf="isSingleBrandSelect(row); else brandCheckboxes"
                >
                  <label
                    *ngFor="
                      let opt of filterOptions(
                        rowBrandOptions[i] || [],
                        dropdownSearch[i + '_brand']
                      )
                    "
                    class="radio-option"
                  >
                    <input
                      type="radio"
                      [name]="'brandList_' + i"
                      [value]="opt.value"
                      [checked]="isEpChecked(row.brandList, opt.value)"
                      (change)="onBrandRadioChange(row, opt.value)"
                    />
                    <span>{{ opt.label }}</span>
                  </label>
                </ng-container>
                <ng-template #brandCheckboxes>
                  <label
                    *ngFor="
                      let opt of filterOptions(
                        rowBrandOptions[i] || [],
                        dropdownSearch[i + '_brand']
                      )
                    "
                    class="checkbox-option"
                    title="{{ opt.value }}"
                  >
                    <input
                      type="checkbox"
                      [checked]="isEpChecked(row.brandList, opt.value)"
                      (change)="onBrandChange(row, opt.value)"
                    />
                    <span>{{ opt.label }}</span>
                  </label>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-cell grid-cell--center">
          <button
            class="btn-duplicate"
            (click)="duplicateRow(i)"
            title="Duplicate Row"
          >
            <img src="assets/images/common/Duplicate.svg" alt="duplicate" />
          </button>
        </div>
      </div>

      <!-- Empty State -->
      <div class="grid-empty" *ngIf="rows.length === 0">
        No rows available. Click "Add New Row" to begin.
      </div>
    </div>
  </div>
</div>
<!-- Footer Buttons -->
<div class="topics-footer" *ngIf="hasSnapshotConfiguration">
  <div class="SnapshotButtonFields" (click)="submit()">
    <div class="button-img t-submit"></div>
    <div class="SnapshotButton">Submit</div>
  </div>
  <div class="SnapshotButtonFields" (click)="deleteRows()">
    <div class="button-img t-delete"></div>
    <div class="SnapshotButton">Delete</div>
  </div>
  <div class="SnapshotButtonFields" (click)="downloadUserGuide()">
    <div class="button-img t-guide"></div>
    <div class="SnapshotButton">Download User Guide</div>
  </div>
</div>
